import resume from "../../assets/images/resume.jpg"
export const resumeBuilder = {
  title: 'Resume Builder',
  description: `Improve your job search success with our powerful AI-powered resume optimization tool, designed to help you craft a standout and effective resume.`,
  cta: 'Build Resume',
  image: resume,
  launched: true,
  link: '/resume',
};
